let fullLength = require('./../common').fullLength;
let reverse  = require('./../common').reverse;
let CBean = require('./../cr-agreement/bean').default;
let gtdId = require('./../common').gtdId;
let fullHex = require('./../common').fullHex;

// 数据下发工具类

var Assemble = {};
// .includes 转为es5 start----------
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            if (this == null) {//this是空或者未定义，抛出错误
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);//将this转变成对象
            var len = o.length >>> 0;//无符号右移0位，获取对象length属性，如果未定义就会变成0

            if (len === 0) {//length为0直接返回false未找到目标值
                return false;
            }

            var n = fromIndex | 0;//查找起始索引
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);//计算正确起始索引，因为有可能是负值

            while (k < len) {//从起始索引处开始循环
                if (o[k] === searchElement) {//如果某一位置与寻找目标相等，返回true，找到了
                    return true;
                }
                k++;
            }
            return false;//未找到，返回false
        }
    });
}
// .includes 转为es5 end----------

Assemble.Department = function (departments, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in departments) {
        var department = departments[i];
        if (department.dId.toString() || !department.name) continue;
        var bean = {};
        bean.dSort = '02';
        bean.dId = gtdId(department.dId);
        bean.dData = Common.aTxt(department.name, encoding);
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Group = function (groups, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in groups) {
        var group = groups[i];
        if (!group.dId.toString() || !group.name) continue;
        var bean = {};
        bean.dSort = '03';
        bean.dId = gtdId(group.dId);
        var dData = '';
        dData += Common.aTxt(group.name, encoding);
        dData += Common.abit1(group.department);
        dData += aFloat(group.gtArr());
        if (group.putType1)
            dData += Common.abit4(group.putType1);
        if (group.barType1)
            dData += Common.abit4(group.barType1);
        if (group.barSgin1)
            dData += Common.abit4(group.barSgin1);
        if (group.putType2)
            dData += Common.abit4(group.putType2);
        if (group.barType2)
            dData += Common.abit4(group.barType2);
        if (group.barSgin2)
            dData += Common.abit4(group.barSgin2);
        bean.dData = dData;
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.PLU = function (plus, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in plus) {
        var plu = plus[i];
        if (!plu.dId) continue;
        var bean = {};
        bean.dSort = '04';
        bean.dId = gtdId(plu.dId);
        var dData = '';
        dData += Common.aTxt(plu.name, encoding);
        dData += Common.abit1(plu.weigth);
        dData += Common.float2SPF(plu.price);
        dData += aFloat(plu.gtArr());

        if (plu.number)
            dData += Common.abit4(plu.number);
        if (plu.indexBar)
            dData += Common.aTxt(plu.indexBar, encoding);

        if (plu.useDatePut)
            dData += Common.abit1(plu.useDatePut);
        if (plu.useDateData)
            dData += Common.abit2(plu.useDateData);

        if (plu.costTrade)
            dData += Common.float2SPF(plu.costTrade);
        if (plu.trae)
            dData += Common.float2SPF(plu.trae);
        if (plu.group)
            dData += Common.abit2(plu.group);
        if (plu.putType1)
            dData += Common.abit2(plu.putType1);
        if (plu.barNo1)
            dData += Common.abit2(plu.barNo1);
        if (plu.barType1)
            dData += Common.abit2(plu.barType1);
        if (plu.putType2)
            dData += Common.abit2(plu.putType2);
        if (plu.barNo2)
            dData += Common.abit2(plu.barNo2);
        if (plu.barType2)
            dData += Common.abit2(plu.barType2);
        if (plu.text1)
            dData += Common.aTxt(plu.text1);
        if (plu.text2)
            dData += Common.aTxt(plu.text2);
        if (plu.text3)
            dData += Common.aTxt(plu.text3);
        if (plu.text4)
            dData += Common.aTxt(plu.text4);
        if (plu.text5)
            dData += Common.aTxt(plu.text5);
        if (plu.text6)
            dData += Common.aTxt(plu.text6);
        if (plu.text7)
            dData += Common.aTxt(plu.text7);

        if (plu.taxType)
            dData += Common.abit1(plu.taxType);
        if (plu.taxExtreme)
            dData += Common.abit4(plu.taxExtreme);
        if (plu.picNo)
            dData += Common.abit2(plu.picNo);
        if (plu.saleDatePut)
            dData += Common.abit1(plu.saleDatePut);
        if (plu.saleDateData)
            dData += Common.abit2(plu.saleDateData);

        if (plu.saleTimePut)
            dData += Common.abit1(plu.saleTimePut);
        if (plu.saleTimeData)
            dData += Common.abit2(plu.saleTimeData);

        if (plu.packDatePut)
            dData += Common.abit1(plu.packDatePut);
        if (plu.packDateData)
            dData += Common.abit2(plu.packDateData);

        if (plu.packTimePut)
            dData += Common.abit1(plu.packTimePut);
        if (plu.packTimeData)
            dData += Common.abit2(plu.packTimeData);

        if (plu.manualDiscountLower)
            dData += Common.abit1(plu.manualDiscountLower);
        if (plu.manualDiscountLowerValue)
            dData += Common.float2SPF(plu.manualDiscountLowerValue);
        if (plu.manualDiscountUpper)
            dData += Common.abit1(plu.manualDiscountUpper);
        if (plu.manualDiscountUpperValue)
            dData += Common.float2SPF(plu.manualDiscountUpperValue);

        if (plu.customDiscount0Type)
            dData += Common.abit1(plu.customDiscount0Type);
        if (plu.customDiscount0UseDate)
            dData += Common.abit1(plu.customDiscount0UseDate);
        if (plu.customDiscount0Lower)
            dData += Common.float2SPF(plu.customDiscount0Lower);
        if (plu.customDiscount0Upper)
            dData += Common.float2SPF(plu.customDiscount0Upper);
        if (plu.customDiscount0Value)
            dData += Common.float2SPF(plu.customDiscount0Value);

        if (plu.customDiscount1Type)
            dData += Common.abit1(plu.customDiscount1Type);
        if (plu.customDiscount1UseDate)
            dData += Common.abit1(plu.customDiscount1UseDate);
        if (plu.customDiscount1Lower)
            dData += Common.float2SPF(plu.customDiscount1Lower);
        if (plu.customDiscount1Upper)
            dData += Common.float2SPF(plu.customDiscount1Upper);
        if (plu.customDiscount1Value)
            dData += Common.float2SPF(plu.customDiscount1Value);

        if (plu.customDiscount2Type)
            dData += Common.abit1(plu.customDiscount2Type);
        if (plu.customDiscount2UseDate)
            dData += Common.abit1(plu.customDiscount2UseDate);
        if (plu.customDiscount2Lower)
            dData += Common.float2SPF(plu.customDiscount2Lower);
        if (plu.customDiscount2Upper)
            dData += Common.float2SPF(plu.customDiscount2Upper);
        if (plu.customDiscount2Value)
            dData += Common.float2SPF(plu.customDiscount2Value);

        if (plu.customDiscount3Type)
            dData += Common.abit1(plu.customDiscount3Type);
        if (plu.customDiscount3UseDate)
            dData += Common.abit1(plu.customDiscount3UseDate);
        if (plu.customDiscount3Lower)
            dData += Common.float2SPF(plu.customDiscount3Lower);
        if (plu.customDiscount3Upper)
            dData += Common.float2SPF(plu.customDiscount3Upper);
        if (plu.customDiscount3Value)
            dData += Common.float2SPF(plu.customDiscount3Value);

        if (plu.sspValue1)
            dData += Common.abit4(plu.sspValue1);
        if (plu.sspValue2)
            dData += Common.abit4(plu.sspValue2);
        if (plu.sspValue3)
            dData += Common.abit4(plu.sspValue3);
        if (plu.sspValue4)
            dData += Common.abit4(plu.sspValue4);

        if (plu.pluType)
            dData += Common.abit1(plu.pluType);
        if (plu.pluSgin)
            dData += Common.abit2(plu.pluSgin);
        if (plu.pluSginValue)
            dData += Common.abit4(plu.pluSginValue);
        if (plu.pingyinSearch)
            dData += Common.aTxt(plu.pingyinSearch, encoding);

        bean.dData = dData;
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.BarCode = function (barCodes, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in barCodes) {
        var barCode = barCodes[i];
        if (!barCode.dId.toString() || !barCode.name) continue;
        var bean = {};
        bean.dSort = '05';
        bean.dId = gtdId(plu.dId);
        var dData = '';
        dData += Common.aTxt(barCode.name, encoding);
        dData += Common.abit1(barCode.type);
        dData += Common.aTxt(barCode.description, encoding);
        dData += aFloat(barCode.gtArr());

        if (barCode.checkType)
            dData += Common.abit1(barCode.checkType);
        if (barCode.constant1)
            dData += Common.abit4(barCode.constant1);
        if (barCode.constant2)
            dData += Common.abit4(barCode.constant2);

        bean.dData = dData;
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Put = function (puts, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in puts) {
        var put = puts[i];
        if (!put.dId.toString() || !put.name) continue;
        var bean = {};
        bean.dSort = '06';
        bean.dId = gtdId(put.dId);
        var dData = '';
        dData += Common.aTxt(put.name, encoding);
        dData += Common.abit1(put.type);
        dData += Common.abit1(put.fontMode);
        dData += Common.abit1(put.high);
        dData += Common.abit1(put.width);
        dData += Common.abit1(put.sonCount);
        dData += aFloat(put.gtArr());

        if (put.text0)
            dData += Common.aTxt(put.text0, encoding);
        if (put.text1)
            dData += Common.aTxt(put.text1, encoding);
        if (put.text2)
            dData += Common.aTxt(put.text2, encoding);
        if (put.text3)
            dData += Common.aTxt(put.text3, encoding);
        if (put.text4)
            dData += Common.aTxt(put.text4, encoding);
        if (put.text5)
            dData += Common.aTxt(put.text5, encoding);
        if (put.text6)
            dData += Common.aTxt(put.text6, encoding);
        if (put.text7)
            dData += Common.aTxt(put.text7, encoding);
        if (put.text8)
            dData += Common.aTxt(put.text8, encoding);
        if (put.text9)
            dData += Common.aTxt(put.text9, encoding);
        if (put.text10)
            dData += Common.aTxt(put.text10, encoding);
        if (put.text11)
            dData += Common.aTxt(put.text11, encoding);
        if (put.text12)
            dData += Common.aTxt(put.text12, encoding);
        if (put.text13)
            dData += Common.aTxt(put.text13, encoding);
        if (put.text14)
            dData += Common.aTxt(put.text14, encoding);
        if (put.text15)
            dData += Common.aTxt(put.text15, encoding);
        if (put.text16)
            dData += Common.aTxt(put.text16, encoding);
        if (put.text17)
            dData += Common.aTxt(put.text17, encoding);
        if (put.text18)
            dData += Common.aTxt(put.text18, encoding);
        if (put.text19)
            dData += Common.aTxt(put.text19, encoding);
        if (put.text20)
            dData += Common.aTxt(put.text20, encoding);
        if (put.text21)
            dData += Common.aTxt(put.text21, encoding);
        if (put.text22)
            dData += Common.aTxt(put.text22, encoding);
        if (put.text23)
            dData += Common.aTxt(put.text23, encoding);
        if (put.text24)
            dData += Common.aTxt(put.text24, encoding);
        if (put.text25)
            dData += Common.aTxt(put.text25, encoding);
        if (put.text26)
            dData += Common.aTxt(put.text26, encoding);
        if (put.text27)
            dData += Common.aTxt(put.text27, encoding);
        if (put.text28)
            dData += Common.aTxt(put.text28, encoding);
        if (put.text29)
            dData += Common.aTxt(put.text29, encoding);
        if (put.text30)
            dData += Common.aTxt(put.text30, encoding);
        if (put.text31)
            dData += Common.aTxt(put.text31, encoding);

        for (var j in put.putSons) {
            var son = put.putSons[j];
            dData += Common.abit1(son.number);
            dData += Common.abit1(son.sgin0);
            dData += Common.abit1(son.sgin1);
            dData += Common.abit1(son.sgin2);
            dData += Common.abit1(son.term);
            dData += Common.abit1(son.angle);
            dData += Common.abit1(son.align);
            dData += Common.abit1(son.fontNum);
            dData += Common.abit2(son.horizontal);
            dData += Common.abit2(son.vertical);
            dData += Common.abit2(son.width);
            dData += Common.abit2(son.high);
        }

        bean.dData = dData;
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Assistant = function (assistants, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in assistants) {
        var assistant = assistants[i];
        // if (!assistant.dId || !assistant.name) continue;
        var bean = {};
        bean.dSort = '07';
        bean.dId = gtdId(assistant.dId);
        var dData = '';
        dData += Common.aTxt(assistant.name, encoding);
        dData += aFloat(assistant.gtArr());

        if (assistant.pwd)
            dData += Common.abit4(assistant.pwd);
        if (assistant.discountLower)
            dData += Common.abit1(assistant.discountLower);
        if (assistant.discountUpper)
            dData += Common.abit1(assistant.discountUpper);
        if (assistant.security)
            dData += Common.abit4(assistant.security);
        if (assistant.number)
            dData += Common.aTxt(assistant.number, encoding);

        bean.dData = dData;
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Data = function (datas) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in datas) {
        var data = datas[i];
        if (!data.dId.toString() || !data.value) continue;
        var bean = {};
        bean.dSort = '08';
        bean.dId = gtdId(data.dId);
        bean.dData = fullHex(parseInt(data.value).toString(16));
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Text = function (texts, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in texts) {
        var text = texts[i];
        if (!text.dId.toString() || !text.value) continue;
        var bean = {};
        bean.dSort = '09';
        bean.dId = gtdId(text.dId);
        bean.dData = Common.aTxt(text.value, encoding);
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Keyboard = function (keyboards) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in keyboards) {
        var keyboard = keyboards[i];
        if (!keyboard.dId.toString() || !keyboard.value) continue;
        var bean = {};
        bean.dSort = '0A';
        bean.dId = gtdId(keyboard.dId);
        bean.dData = fullHex(parseInt(keyboard.value).toString(16));
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Character_bank = function (character_banks, encoding) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in character_banks) {
        var character_bank = character_banks[i];
        if (!character_bank.dId.toString() || !character_bank.dData) continue;
        var bean = {};
        bean.dSort = '0B';
        bean.dId = gtdId(character_bank.dId);
        bean.dData = Common.aTxt(character_bank.dData, encoding);
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Bitmaps = function (bitmapss) {
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in bitmapss) {
        var bitmaps = bitmapss[i];
        if (!bitmaps.dId.toString() || !bitmaps.dData) continue;
        var bean = {};
        bean.dSort = '0C';
        bean.dId = gtdId(bitmaps.dId);
        bean.dData = fullHex(parseInt(bitmaps.dData).toString(16));
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

Assemble.Communication = function (dId) {
    if (!dId) return;
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [];
    ret.dCmd = '01';
    var bean = {};
    bean.dSort = 'FF';
    bean.dId = gtdId(dId);
    arr.push(bean);
    ret.dataParts = arr;
    return ret;
};

/**
 * 数据参数组装
 * @param datas
 * @returns {any}
 * @constructor
 */
Assemble.Truck_Data = function (datas, encoding) {
  console.log(CBean.send)
    var ret = JSON.parse(JSON.stringify(CBean.send)),
        arr = [],
        i;
    for (i in datas) {
        var data = datas[i];
        if (!data.dId.toString() || !data.value) continue;
        var bean = {};
        bean.dSort = '0201';
        bean.dId = gtdId(data.dId);
        bean.dData = fullHex(parseInt(data.value).toString(16));
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

/**
 * 拼装浮动标志
 * @param arr
 * @returns {string}
 */
var aFloat = function (arr) {
        if (!arr || arr.length == 0) {
            return '00';
        }

        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        var arr4 = [];
        var arr5 = [];
        var arr6 = [];
        var arr7 = [];
        var arr8 = [];
        var arr9 = [];
        for (var i = 0; i < 63; i++) {
            if (i < 7) {
                gtFloatPart(arr1, arr, i);
            }
            if (i >= 7 && i < 15) {
                gtFloatPart(arr3, arr, i);
            }
            if (i >= 15 && i < 23) {
                gtFloatPart(arr4, arr, i);
            }
            if (i >= 23 && i < 31) {
                gtFloatPart(arr5, arr, i);
            }
            if (i >= 31 && i < 39) {
                gtFloatPart(arr6, arr, i);
            }
            if (i >= 39 && i < 47) {
                gtFloatPart(arr7, arr, i);
            }
            if (i >= 47 && i < 55) {
                gtFloatPart(arr8, arr, i);
            }
            if (i >= 55) {
                gtFloatPart(arr9, arr, i);
            }
        }

        gtCollect(arr2, arr3);
        gtCollect(arr2, arr4);
        gtCollect(arr2, arr5);
        gtCollect(arr2, arr6);
        gtCollect(arr2, arr7);
        gtCollect(arr2, arr8);
        gtCollect(arr2, arr9);
        arr2.push('0');
        gtCollect(arr1, arr2);

        var cmd = '';
        cmd += pushLength(parseInt(list2String(arr1), 2).toString(16), 2);
        if (arr2.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr2), 2).toString(16), 2);
        }
        if (arr3.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr3), 2).toString(16), 2);
        }
        if (arr4.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr4), 2).toString(16), 2);
        }
        if (arr5.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr5), 2).toString(16), 2);
        }
        if (arr6.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr6), 2).toString(16), 2);
        }
        if (arr7.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr7), 2).toString(16), 2);
        }
        if (arr8.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr8), 2).toString(16), 2);
        }
        if (arr9.includes('1')) {
            cmd += pushLength(parseInt(list2String(arr9), 2).toString(16), 2);
        }
        return cmd;
    },
    /**
     * 获取1，3-9 float 标志
     * @param float
     * @param arr
     * @param index
     */
    gtFloatPart = function (float, arr, index) {
        if (arr.length <= index) {
            float.push('0');
        } else {
            if (arr[index]) {
                float.push('1')
            } else {
                float.push('0');
            }
        }
    },
    /**
     * 获取2 float 标志
     * @param source
     * @param target
     */
    gtCollect = function (source, target) {
        if (target && target.length > 0) {
            if (isInArray(target, '1')) {
                source.push('1');
            } else {
                source.push('0');
            }
        } else {
            source.push('0');
        }
    },
    /**
     * 使用循环的方式判断一个元素是否存在于一个数组中
     * @param {Object} arr 数组
     * @param {Object} value 元素值
     */
    isInArray = function (arr, value) {
        for (var i = 0; i < arr.length; i++) {
            if (value === arr[i]) {
                return true;
            }
        }
        return false;
    },
    /**
     * 内容数据包组装
     * @param send
     * @param nid
     * @returns {string}
     */
    package_inner = function (send) {
        var arr = send.dataParts,
            content = '',
            i = 0;
        for (i in arr) {
            var mark = send.dCmd +
                (arr[i].dSort.length / 2 == 1 ? '0' : '1') +
              fullLength((arr[i].dId.length / 2).toString(2), 3);

            var len = arr[i].dSort.length + arr[i].dId.length + arr[i].dData.length;

            var hexLen = (len / 2).toString(16);
            if (hexLen.length % 2 != 0) {
                hexLen = '0' + hexLen;
            }
            var dLen = reverse(hexLen);

            var markLen = (dLen.length / 2).toString(2);
            if (markLen.length % 2 != 0) {
                markLen = '0' + markLen;
            }
            mark += markLen;

            var dMark = parseInt(mark, 2).toString(16);

            content += dMark + dLen + reverse(arr[i].dSort) + arr[i].dId + arr[i].dData
        }
        return content;
    },
    /**
     * 数据整包拼装
     * @param send
     * @param nid
     * @returns {{cmd: string, nid: *}}
     */
        package = function (send, nid) {
        var arr = send.dataParts,
            content = '',
            i = 0,
            cmd = '02';
        for (i in arr) {
            var mark = send.dCmd;

            if (arr[i].dSort.length / 2 == 1) {
                mark += '0';
            } else {
                mark += '1';
            }

            mark += fullLength((arr[i].dId.length / 2).toString(2), 3);

            var len = arr[i].dSort.length + arr[i].dId.length + arr[i].dData.length;
            var hexLen = (len / 2).toString(16);
            if (hexLen.length % 2 != 0) {
                hexLen = '0' + hexLen;
            }
            var dLen = reverse(hexLen);

            var markLen = (dLen.length / 2).toString(2);
            if (markLen.length % 2 != 0) {
                markLen = '0' + markLen;
            }
            mark += markLen;

            var dMark = parseInt(mark, 2).toString(16);

            content += dMark + dLen + reverse(arr[i].dSort) + arr[i].dId + arr[i].dData
        }

        var dataLength = content.length / 2;

        var mark = '0000' + parseInt('3').toString(2);
        var lenHexLength = dataLength.toString(16).length;
        if (lenHexLength % 2 != 0) {
            lenHexLength = (parseInt(lenHexLength / 2) + 1).toString(2);
        } else {
            lenHexLength = (parseInt(lenHexLength / 2)).toString(2);
        }
        if (lenHexLength % 2 != 0) {
            mark += '0' + lenHexLength;
        } else {
            mark += lenHexLength;
        }
        mark = parseInt(mark, 2).toString(16);
        if (mark.length != 2) {
            mark = '0' + mark;
        }

        cmd += mark;

        var nid = gtNid(nid);
        cmd += nid;

        var hexLength = dataLength.toString(16);
        if (hexLength.length % 2 != 0) {
            hexLength = '0' + hexLength;
        }

        hexLength = reverse(hexLength);
        cmd += hexLength;

        var contentData = hex2Ascii(str2Hex(content));
        cmd += contentData;
        cmd += '03';
        return {
            cmd: cmd,
            nid: nid
        };
    },

    /**
     * 拼装 Content Mark
     * @param mark
     * @param content
     * @returns {string}
     */
    assembleMark = function (mark, content) {
        var markStr = '';
        markStr += mark.encrypt ? '1' : '0';
        markStr += mark.ack ? '1' : '0';
        markStr += mark.remark ? mark.remark : '00';
        markStr += mark.cd ? mark.cd : parseInt('3').toString(2);

        var dataLength = content.length / 2;

        var lenHexLength = dataLength.toString(16).length;
        if (lenHexLength % 2 != 0) {
            lenHexLength = (parseInt(lenHexLength / 2) + 1).toString(2);
        } else {
            lenHexLength = (parseInt(lenHexLength / 2)).toString(2);
        }
        if (lenHexLength % 2 != 0) {
            markStr += '0' + lenHexLength;
        } else {
            markStr += lenHexLength;
        }
        markStr = parseInt(markStr, 2).toString(16);
        if (markStr.length != 2) {
            markStr = '0' + markStr;
        }
        return markStr;
    },
    /**
     * 响应数据包拼装
     * @param send
     * @param nid
     * @returns {{cmd: string, nid: *}}
     */
    responsePackage = function (resquest, state) {
        var cmd = '02';
        var length = resquest.contentLength.toString(16);
        if (length.length % 2 != 0) length = "0" + length;
        var content = state + reverse(length);
        resquest.mark.ack = true;
        cmd += assembleMark(resquest.mark, content);
        cmd += resquest.nid;

        var hexLength = (content.length / 2).toString(16);
        if (hexLength.length % 2 != 0) {
            hexLength = '0' + hexLength;
        }
        hexLength = reverse(hexLength);
        cmd += hexLength + content;
        cmd += '03';
        return cmd;
    };
module.exports = {
  package_inner:package_inner,
  Assemble:Assemble
};



//////////////////
// WEBPACK FOOTER
// ./api/agreement/cr-agreement/assemble.js
// module id = WFrX
// module chunks = 28